import { render, staticRenderFns } from "./percentSgr.vue?vue&type=template&id=25d3e416"
import script from "./percentSgr.vue?vue&type=script&lang=js"
export * from "./percentSgr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports